(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2761],{

/***/ 40002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-beginners-2022/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Mercari",
      title: "Mercari for Beginners: The Ultimate Guide 2022",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Mercari is a marketplace platform created in 2013 by a team of Japanese entrepreneurs who wanted an easier way for shoppers to buy secondhand goods online. Mercari started as an app that people could use on their phones but has evolved into a global marketplace with over 15 million users.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Due to its growing popularity, this Japanese e-commerce has just made its way into the United States. It allows U.S. and Japanese residents to buy and sell almost anything, making it easy to find whatever you are looking for. Another great feature about Mercari is that it charges low selling fees compared to other e-commerce marketplaces like eBay and Poshmark, which we will discuss later.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Who uses Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Mercari is the \u201Cnew kid in the block\u201D alongside Poshmark, Depop, and Etsy. But this doesn\u2019t mean only a few people use this app. This marketplace app caters to a whopping 19 million monthly active users.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["There are a combined total of 55 million app downloads globally, and 20 million of those came from the U.S. Despite being new in the U.S., this app still has an impressive number of users. These numbers could be your potential customers for your reselling business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Mercari is an ideal app for resellers looking to expand their market or earn extra cash. Most users of this app are collectors or buyers looking for a great deal and lower prices. So if you have items you no longer want to use or want to declutter your closet, Mercari can be the ideal app for you!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Top Selling Items on Mercari "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As their slogan states, you can pretty much buy and sell anything on Mercari. Of course, you cannot buy and sell anything illegal like drugs, counterfeit items, or weapons. If you\u2019re a new Mercari seller, you may be wondering what items are best to sell on this platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Some of the best items to sell on Mercari are items and brands that also sell well on other platforms like Poshmark, eBay, and Depop. It pays to do quick product research first on top-selling items on these platforms. To get you started; Clothes, shoes, electronics, toys, and collectibles are some of the best-selling categories on Mercari.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Sell on Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["What most resellers like on Mercari is how user-friendly their platform is. You can easily buy and sell items you like, including a hassle-free shipping option for all your sold items and low selling fees.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you are looking for a new way to eliminate clutter, why not sell it? Mercari is the best option for people new to reselling and a good side-hustle in making extra cash.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Make an Account "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You need to make an account first before listing an item for sale on Mercari. "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Go to ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.mercari.com/",
            children: "Mercari.com"
          }), ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \u201CSign Up\u201D "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter your personal information (Name, email address, etc.) "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["We suggest adding a profile picture and filling up all the relevant information to make your selling account look more trustworthy. After creating your account, you can see all the previously entered data on your dashboard.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Get yourself familiarized with other buttons such as notifications, balances, and listings. In this way, it will be easier for you to locate things more easily.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Start Listing "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["After creating an account, let us move on to the fun part. Make your first listing! Making a listing can be tricky and complicated at first, but you can do it within minutes once you get the hang of it.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are some things you need to consider when making a listing: "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "1. Listing Title "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your listing title is one of the essential parts of your listing. As much as possible, all the relevant information about your product must be within the 40 character limit. Make sure your title is compact with relevant keywords. In this way, people searching for a specific item or brand can easily see your listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When writing a listing title, make sure to include the following: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Brand Name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Style"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Category (Men, Women, Kids, etc.)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Season"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Condition (Used, NWT, etc.)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Size "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Color "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "What materials is it made of (Cotton, Leather, etc.)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "2. Product Description "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The product description is where you can enter all other relevant information about your items in detail. Since listing titles have a character limit, you can maximize this to make your listing searchable."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In this portion, be as detailed as possible. Include all the relevant information and be honest in the item's overall condition. Always include actual measurements instead of estimation. For example, write \u201C23 cm in length\u201D instead of \u201CJust right above the knee.\u201D Always include what materials it is made of, especially for clothing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Also, state any signs of wear, tear, holes, or stains. This helps you prevent any unwanted complaints and returns from unhappy customers. Plus, the more information you give in, the higher the chance of selling it faster. In case you missed something or forgot to include other relevant information. You can also go back and edit the listing until it's sold.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "3. Quality Photo "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This is the heartbeat of almost every listing. The better the image quality is, the more interested potential buyers can be. A clutter-free background, a neat and clean item, and a great angle are what make an item sold in just a few minutes- or even seconds.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can put up to 12 photos in one Mercari listing. So make sure to maximize it. Remember, buyers would like to see the items that they are buying. Make sure to take pictures of its front, back, sides, tags (if it\u2019s brand new), and other relevant details.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Also, make sure that the item is evident in the first picture. You can add accessories that can make the item pop or improve the quality of the photo using a photo editing app. Just make sure not to overdo or add unnecessary filters that can alter the color or condition of your item.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "4. Pricing "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When pricing your items on Mercari, you may want to do a little research first. Look for similar products on Mercari and other platforms. Remember to price your items fairly alongside your competitor\u2019s price. An overprice item can be hard to sell. In comparison, items sold at a reasonable price or free shipping can help you close a deal faster.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Keep in mind that the final price still depends on the seller. Listing on Mercari is free, but they will charge 10% once the item is sold.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Mercari Selling Fees "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Before you put in your listing price, you should consider the following Mercari selling fees: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Selling Fees - All sold items are charged 10% from their sale. Meaning, if you sell an item for $10, they will take $1 from it. So your take-home earnings are $9.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Payment Processing Fees - Mercari charges a rate of 2.9% + $0.30 for each payment received from each buyer. This charge applies to all forms of income received from the buyer.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Direct Transfer Fee - They will charge $2 for each direct deposit of $10 and under. No fees will be charged for a direct deposit of $10 or more to your bank account.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Rejected Direct Deposit - They will charge $2 for each declined transaction under the seller\u2019s bank and return it to the seller\u2019s Mercari balance.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Instant Pay Transfer - They will charge $2 for each completed transaction under real-time bank transfer.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your total earnings are equal to your listing price minus the selling fee, processing fee, and shipping (if you choose to offer free shipping). All these fees are deducted from the seller after the order has been completed.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How Sellers are Paid "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["There are two ways to withdraw your earnings from Mercari. The direct deposit and the Instant pay transfer.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "1. Direct Deposit"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In order to withdraw your earnings and deposit them on your bank account, simply request a cash-out request to your bank using direct deposit. Mercari does not charge any fee for a direct deposit of $10 or more. However, you will be charged $2 for each rejected transfer or if the amount you want to transfer is under $10.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This transaction is usually processed within 5-10 business days or depending on your bank\u2019s processing times.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "2. Instant Pay Transfer "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In order to withdraw your earnings faster, you have the option to choose an Instant Pay transfer. Just click \u201CMy balances,\u201D select \u201CInstant Pay,\u201D complete the I.D. validation (if it\u2019s your first time), and add a debit card.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Mercari allows the use of instant pay up to $500 per month, once per day, on eligible debit cards. However, there is a $2 flat rate per transfer. This is a real-time transfer. But at times, depending on your bank\u2019s processing time, it can take up to 30 minutes before the transfer can be reflected in your bank account.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Mercari Rating System "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The Mercari Rating system has its advantages and disadvantages for buyers and sellers. After the sale has been completed, the buyer must leave a rating of 1 to 5 stars. It usually comes along with a comment about their experience. If the customer forgot to give you a review three days after the item was delivered, Mercari would automatically give you 5 stars.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Additionally, Mercari will only release the buyer\u2019s payment they gave you a review or three days after the item was successfully delivered. Mercari also has badges where you can see more information about the seller.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Some of these badges include:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "How long they\u2019ve been on Mercari (Member since 20XX)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Quick Shipper (Ship items within 24 hours, excluding weekends and holidays)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Reliable (Zero to minimal order cancellations)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Fast Responder (Answers question within 12 hours) "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Packing and Shipping "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Mercari allows several shipping options that you can choose from. But first, you have to decide who pays for the shipping. If you decide to offer free shipping, it simply means you will pay for the shipping fee, and Mercari will deduct the amount from your earnings.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["For the shipping option, You can choose between the Mercari shipping label or ship it on your own using other couriers available in your area. If you prefer to send it using Mercari\u2019s prepaid label, they will email you the shipping label after placing the order. Simply select the weight class of the item and select from the available couriers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can choose between FedEx, USPS, and UPS. The rates will depend according to its weight class. UPS also offers a \u201CMercari pack and ship\u201D option, where you just need to bring the item, and they\u2019ll pack it for you. Although this packing service option is much more expensive, it is still ideal for busy people.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Packing Materials"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are some of the packaging and shipping materials you will need to sell on Mercari. "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Weighing Scale"
          }), " - This is important, especially for bulky items. Remember that any excess in the weight will be charged to the seller, so it\u2019s best to be accurate than estimate your item's correct weight.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Printer"
          }), " - You will need a printer to print the shipping label of your sold items. If reselling is just your side-hustle, you can always go to the post office to have it printed or ask your neighbor to print the shipping label for you."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Sheet Labels"
          }), " - This is optional though this provides you a lot of conveniences. Simply print, peel, and stick the label on your package.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Poly mailers or Mailing Envelopes"
          }), " - Poly mailers can be your go-to shipping material if you sell small items or clothing. These are cheaps and eco-friendly."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Shipping Boxes"
          }), " - USPS Priority mailboxes are free and suitable for heavy and fragile items. You can also re-use standard brown boxes or even shoe boxes. Just remember to remove its previous labels.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Final Thoughts "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Amidst being new in the market, Mercari is still safe and provides an easy way to earn extra cash. You don\u2019t need to have a closet full of inventory to start selling. Simply choose items you no longer use or want in your closet, post it on Mercari, and wait for a potential buyer to transact with.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "But for sellers who are into reselling business, Mercari is an excellent additional platform for your business. In this way, you can broaden your market and make more sales. Plus, you can use bots to easily import your listing from Poshmark or Depop directly to Mercari."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop offers a hassle-free re-listing feature that saves you time rather than doing it manually. On top of it, our intelligent system can also do other things such as liking, following, and sharing, so you don\u2019t have to.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Thousands of marketplace sellers have trusted us. Plus, we offer a free 7-day trial with no commitment and credit card required! Sign up here and see the difference it makes to your reselling business.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-beginners-2022.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Mercari for Beginners: The Ultimate Guide 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Get to know the basics for selling on Mercari! Learn the fundamentals of what Mercari is and how to get started."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-beginners-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-beginners-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Mercari for Beginners: The Ultimate Guide 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Get to know the basics for selling on Mercari! Learn the fundamentals of what Mercari is and how to get started."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 65851:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-beginners-2022",
      function () {
        return __webpack_require__(40002);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(65851); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);